import { render, staticRenderFns } from "./Estadisticas2026.vue?vue&type=template&id=444a467e"
import script from "./Estadisticas2026.vue?vue&type=script&lang=js"
export * from "./Estadisticas2026.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports